import { Observable } from 'rxjs';
import { PopularDestinations } from '../models/popular-destinations.model';

export abstract class PopularDestinationsRepository {
    abstract getPopularDestinations(): Observable<PopularDestinations>;
}
